<template>
  <div>
    <div class="d-flex justify-content-between">
      <div style="width: 240px; margin-left: 15px; background-color: #eff2f7; border-radius: 4px; height: 34px; display: flex; justify-content: center;">
        <button @click="chartFormat= 'day';dataLabelsEnabled=false;renderChartConvert();rotate=false;offsetY=0" :disabled="chartFormat === 'day'" class="button-month-week" :style="{ backgroundColor: chartFormat === 'day' ? '#556ee6d9' : '#ffffff' }">日間</button>
        <button @click="chartFormat= 'week';dataLabelsEnabled=true;renderChartConvert();rotate=false;offsetY=0" :disabled="chartFormat === 'week'" class="button-month-week" :style="{ backgroundColor: chartFormat === 'week' ? '#556ee6d9' : '#ffffff' }">週間</button>
        <button @click="chartFormat= 'month';dataLabelsEnabled=false;renderChartConvert();rotate=true;offsetY=12" :disabled="chartFormat === 'month'" class="button-month-week" :style="{ backgroundColor: chartFormat === 'month' ? '#556ee6d9' : '#ffffff' }">月間</button>
      </div>
      <h1 style="text-align: center; line-height: 34px;">歩数グラフ</h1>
      <div style="width: 240px; height: 34px;" class="d-flex justify-content-end">
        <b-button @click="closeModal" class="btn-lyg w-lg">戻る</b-button>
      </div>
    </div>
    <div v-if="chartFormat === 'week'" class="input-group" style="width: 200px; margin-left: 15px; ">
      <div class="input-group-prepend pointer">
        <span class="input-group-text p-1" @click="prevWeek">
          <svg style="transform: scale(0.7)" width="24" height="24" fill-rule="evenodd" clip-rule="evenodd">
            <path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z"/>
          </svg>
        </span>
      </div>
      <input type="text" class="form-control text-center py-1" readonly :value="displayRange">
      <div class="input-group-append pointer" :class="{disabled: isFuture()}" @click="nextWeek">
        <span class="input-group-text p-1">
          <svg style="transform: scale(0.7)" width="24" height="24" fill-rule="evenodd" clip-rule="evenodd">
            <path d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z"/>
          </svg>
        </span>
      </div>
    </div>
    <div v-if="chartFormat === 'month'" class="input-group" style="width: 200px; margin-left: 15px;">
      <div class="input-group-prepend pointer">
        <span class="input-group-text p-1" @click="prevMonth">
          <svg style="transform: scale(0.7)" width="24" height="24" fill-rule="evenodd" clip-rule="evenodd">
            <path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z"/>
          </svg>
        </span>
      </div>
      <input type="text" class="form-control text-center py-1" readonly :value="displayRangeMonth">
      <div class="input-group-append pointer" :class="{disabled: isFutureMonth()}" @click="nextMonth">
        <span class="input-group-text p-1">
          <svg style="transform: scale(0.7)" width="24" height="24" fill-rule="evenodd" clip-rule="evenodd">
            <path d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z"/>
          </svg>
        </span>
      </div>
    </div>
    <div v-if="chartFormat === 'day'" class="input-group" style="width: 200px; margin-left: 15px;">
      <div class="input-group-prepend pointer">
        <span class="input-group-text p-1" @click="prevDay">
          <svg style="transform: scale(0.7)" width="24" height="24" fill-rule="evenodd" clip-rule="evenodd">
            <path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z"/>
          </svg>
        </span>
      </div>
      <input type="text" class="form-control text-center py-1" readonly :value="displayDay">
      <div class="input-group-append pointer" :class="{disabled: isFutureDay()}" @click="nextDay">
        <span class="input-group-text p-1">
          <svg style="transform: scale(0.7)" width="24" height="24" fill-rule="evenodd" clip-rule="evenodd">
            <path d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z"/>
          </svg>
        </span>
      </div>
    </div>
    <apexchart type="bar" :height="isExpand ? 660 : 400" :options="chartOptions" :series="series" ref="chart" />
  </div>

</template>

<script>
import api from "@/api";
import moment from "moment";
import {keyBy} from "lodash";

export default {
  data() {
    return {
      day: moment(),
      start: '',
      end: '',
      series: this.defaultSeries(),
      chartOptions: {
        colors: ["#556ee6d9"],
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: {show: true},
          zoom: {enabled: false},
          parentHeightOffset: 0,
          offsetY: 10,
        },
        responsive: [{
          options: {
            legend: {
              position: 'bottom',
            }
          }
        }],
        dataLabels: {
          enabled:true,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 5,
            columnWidth: '75%',
            dataLabels: {
              position: 'center',
              total: {
                enabled: false,
                formatter: (value) => Number(value).toFixed(2),
              }
            },
          },
        },
        xaxis: {
          categories: [],
          labels: {
            maxHeight: 60,
          },
        },
        tooltip: {
          enabled: true,
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left'
        },
        fill: {
          opacity: 1
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          },
        },
      },
      healthKit: [],
      show: false,
      firstDayOfMonth:'',
      lastDayOfMonth:'',
      chartFormat:'day',
      dataLabelsEnabled: false,
      rotate: false,
      dataArr: [],
    }
  },
  props: {
    userId: {
      type: Number,
      required: true,
    },
    time_out_facility: {
      type: String,
      required: false
    },
    isExpand: {
      type: Boolean,
    }
  },

  watch: {
    isExpand: {
      handler() {
        if(this.chartFormat === 'week'){
          this.updateChart(this.start, this.end);
        } else if (this.chartFormat === 'month'){
          this.updateChart(this.firstDayOfMonth, this.lastDayOfMonth);
        } else if (this.chartFormat === 'day') {
          this.updateChart(this.day, this.day);
        }
      }
    }
  },

  created() {
    this.getFirstAndLastDayOfMonth();
    this.renderChart();
  },

  computed: {
    displayRange: function () {
      return `${moment(this.start).format('YYYY/MM/DD')}~${moment(this.end).format('DD')}`;
    },
    displayRangeMonth: function () {
      return `${moment(this.firstDayOfMonth).format('YYYY/MM/DD')}~${moment(this.lastDayOfMonth).format('DD')}`;
    },
    displayDay: function() {
      return `${moment(this.day).format('YYYY/MM/DD')}`;
    }
  },

  methods: {

    renderChartConvert(){
      this.getFirstAndLastDayOfMonth();
      this.getMondayAndSunday();
      this.renderChart();
    },

    defaultSeries() {
      return [
        {
          name: '歩数',
          data: [],
        }
      ];
    },
    listDates(start, end) {
      const startDate = moment(start);
      const endDate = moment(end);
      const dateArray = [];

      while (startDate.isSameOrBefore(endDate)) {
        dateArray.push(startDate.format('YYYY-MM-DD'));
        startDate.add(1, 'days');
      }

      return dateArray;
    },
    getMondayAndSunday(date) {
      const inputDate = moment(date);
      const monday = inputDate.clone().startOf('isoWeek');
      const sunday = inputDate.clone().endOf('isoWeek');
      return [monday.format('YYYY-MM-DD'), sunday.format('YYYY-MM-DD')];
    },
    async updateChart(start, end) {
      const res = await api.healthKitList({
        user_id: this.userId,
        key_sort: 'event_date',
        type_sort: 'desc',
        start_date: start,
        end_date: end > moment(this.time_out_facility).format('YYYY-MM-DD') ? moment(this.time_out_facility).format('YYYY-MM-DD') : end,
        // time_out_facility: this.time_out_facility,
        per_page: 31
      })
      if (res.status === 200) {
        const dates = this.listDates(start, end);
        const series = this.defaultSeries();
        const seriesStep = this.defaultSeries();
        this.transformData(res.data.data);
        const items = keyBy(res.data.data, 'event_date');
        let datesFormatted = [];
        let dayFormatted = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
        const dayMapping = {
          'Sun': '日',
          'Mon': '月',
          'Tue': '火',
          'Wed': '水',
          'Thu': '木',
          'Fri': '金',
          'Sat': '土',
        };
        for (let date of dates) {
          series[0].data.push(items[date]?.total_steps || 0);
          datesFormatted.push(moment(date).format(`MM/DD(${dayMapping[moment(date).format('ddd')]})`));
          seriesStep[0].data.push(items[date]?.steps || []);
        }
        this.$refs.chart.updateOptions({dataLabels: {enabled:this.dataLabelsEnabled}});
        this.$refs.chart.updateSeries(series);
        this.$refs.chart.updateOptions({xaxis: {categories: datesFormatted, labels: {rotateAlways: this.rotate,}}, chart: {height: this.isExpand ? 660 : 400}});

        if (this.chartFormat === 'day') {
          this.dataArr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          for (const step of seriesStep[0].data[0]) {
            this.dataArr[moment(step.startDate).hour()] = Math.round(step.value);
          }
          this.$refs.chart.updateSeries([{name: "歩数", data: this.dataArr}]);
          this.$refs.chart.updateOptions({xaxis: {categories: dayFormatted}});
        }
      }
    },

    transformData(data) {
      data.forEach((item) => {
        const dateParts = item.event_date.split('T');
        const date = dateParts[0];
        const totalSteps = item.steps ? item.steps.reduce((accumulator, step) => accumulator + Math.round(step.value), 0): '';
        item.event_date = date;
        item.total_steps = totalSteps;
      });
    },

    renderChart(date = new Date()) {
      const [start, end] = this.getMondayAndSunday(date);
      this.start = start;
      this.end = end;
      this.day = moment(date).format('YYYY-MM-DD');
      if(this.chartFormat === 'week'){
        this.updateChart(start, end);
      } else if (this.chartFormat === 'month'){
        this.updateChart(this.firstDayOfMonth, this.lastDayOfMonth);
      } else if (this.chartFormat === 'day') {
        this.updateChart(this.day, this.day);
      }
    },

    getFirstAndLastDayOfMonth() {
      const currentDate = moment();
      this.firstDayOfMonth = moment(currentDate).startOf('month').format('YYYY-MM-DD');
      this.lastDayOfMonth = moment(currentDate).endOf('month').format('YYYY-MM-DD');
    },

    nextMonth() {
      if (!this.isFutureMonth()) {
        const currentFirstDay = moment(this.firstDayOfMonth);
        this.firstDayOfMonth = currentFirstDay.add(1, 'months').startOf('month').format('YYYY-MM-DD');
        this.lastDayOfMonth = currentFirstDay.endOf('month').format('YYYY-MM-DD');
        this.renderChart()
      }
    },

    prevMonth() {
      const currentFirstDay = moment(this.firstDayOfMonth);
      this.firstDayOfMonth = currentFirstDay.subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      this.lastDayOfMonth = currentFirstDay.endOf('month').format('YYYY-MM-DD');
      this.renderChart()
    },
    nextWeek() {
      if (!this.isFuture()) {
        const nextMonday = moment(this.start).clone().add(7, 'days').toDate();
        this.renderChart(nextMonday);
      }
    },
    prevWeek() {
      const prevMonday = moment(this.start).clone().subtract(7, 'days').toDate();
      this.renderChart(prevMonday);
    },
    nextDay() {
      if (!this.isFutureDay()) {
        const nextDay = moment(this.day).clone().add(1, 'days').toDate();
        this.renderChart(nextDay);
      }
    },
    prevDay() {
      const prevDay = moment(this.day).clone().subtract(1, 'days').toDate();
      this.renderChart(prevDay);
    },
    isFuture() {
      return moment(this.end) >= moment();
    },

    isFutureMonth() {
      const today = moment();
      return today.isSameOrBefore(moment(this.lastDayOfMonth), 'month');
    },

    isFutureDay() {
      return moment(this.day).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');
    },

    closeModal() {
      this.$emit("close");
    },
  }
}
</script>

<style scoped>
.disabled.input-group-append {
  opacity: 0.5;
  cursor: default;
  /* color: #2c3fadc2; */
}
.button {
  height: 2rem;
}
.button-month-week{
  margin: 5px auto 0;
  height: 24px;
  width: 70px;
  border-radius: 10px;
  border: 0px
}
</style>
